import React, { useEffect, useState, useRef } from "react";
import {
  AlertCircle,
  Check,
  MessageCircle,
  Paperclip,
  Printer,
  Send,
  Trash2,
  X,
} from "react-feather";
import { useNavigate, useParams } from "react-router";
import { Alert } from "../../../../Components/Error/Alert";
import {
  Adquirinte,
  IAdquirinte,
} from "../../../../Components/ImovelFocus/Adquirinte";
import { AvaliaçãoContainer } from "../../../../Components/ImovelFocus/AvaliaçãoSection";
import { BenfeitoriasSection } from "../../../../Components/ImovelFocus/BenfeitoriasSection";
import { Header } from "../../../../Components/ImovelFocus/Header";
import { ImovelSection } from "../../../../Components/ImovelFocus/ImovelSection";
import {
  ITransmitente,
  Transmitente,
} from "../../../../Components/ImovelFocus/Transmitente";
import { Anexos } from "../../../../Components/ImovelFocus/Anexos";
import ReactToPrint from "react-to-print";
import { ModalLoader } from "../../../../Components/ModalLoader";
import { useCartorio } from "../../../../Hooks/cartorio";
import { useFuncionarioCartorio } from "../../../../Hooks/funcionarioCartorio";
import api from "../../../../Services/api";
import {
  Container,
  FooterCenterButton,
  FooterLeftButton,
  FooterMessageDiv,
  FooterRightButton,
  HeaderRightButton,
  HelperImpressao,
  Section,
  TitleSection,
  HeaderButtons,
  HeaderRightButtonX,
  HeaderRightTrash,
  HelpContainer,
} from "./styles";
import { EnviarImovel } from "../../../../Components/ImovelFocus/EnviarImovel/Index";
import { usePrefeitura } from "../../../../Hooks/usePrefeitura";
import {
  app_base_url,
  base_url_enderecos_api,
  base_url_unico_api,
} from "../../../../Utils/baseUrl";
import axios from "axios";
import theme from "../../../../Styles/theme";
import { AvaliarImovel } from "../../../../Components/ImovelFocus/AvaliarModal";
import { useFuncionarioPrefeitura } from "../../../../Hooks/funcionarioPrefeitura";
import { MessagesDiv } from "../../../../Components/ImovelFocus/MessagesDiv";
import { GuiaCode } from "../../../../Components/ImovelFocus/GuiaCode";
import { geraCodigo } from "../../../../Components/ImovelFocus/GuiaCode/operationsGuia";
import { Observacoes } from "../../../../Components/ImovelFocus/Observacoes";
import { useAvaliacao } from "../../../../Hooks/avaliado";
import { ConfirmarAvaliacaoModal } from "../../../../Components/ImovelFocus/ConfirmarAvaliacaoModal";
import { ReenviarParaCartorio } from "../../../../Components/ImovelFocus/ReenviarParaCartorio";
import { ImportsNotUsedAsValues } from "typescript";
import { retiraVerificadores } from "../../../../Utils/retiraVerificadores";
import { ExcluirImovelModal } from "../../../../Components/ImovelFocus/ExcluirImovelModal";
import { useGuia } from "../../../../Hooks/guia";

import { PagoDiv } from "../../../../Components/PagoDiv";
import { Button } from "@mui/material";
import { FooterImovelFocus } from "../../../../Components/ImovelFocus/FooterImovelFocus";
import { DuplicarGuiaModal } from "../../../../Components/ImovelFocus/DuplicarGuiaModal";
import { useImovel } from "../../../../Hooks/imoveis";
import { useAdquirinte } from "../../../../Storage/Adquirente";
export interface IImovelFocus {
  ID: number;
  LOCALIZACAO: string;
  BAIRRO: string;
  AREA: number;
  AREA_TRANSMITIDA: number;
  LOTE: string;
  QUADRA: string;
  ZONA: string;
  SUBLOTE: string | null;
  OPERACAO_ID: number;
  VALOR_CARTORIO_TERRENO: number | null;
  VALOR_CARTORIO_BENFEITORIAS: number | null;
  VALOR_PREFEITURA_TERRENO: number | null;
  VALOR_PREFEITURA_BENFEITORIAS: number | null;
  DATA_CRIACAO: string;
  ENVIADO: string | null;
  AVALIADO: string | null;
  PREFEITURA_ID: number;
  CARTORIO_ID: number;
  CARTORIO_TITULO: string;
  FRENTE: number;
  FUNDO: number;
  LADO_DIREITO: number;
  LADO_ESQUERDO: number;
  SITUACAO_QUADRA: string;
  NUMERO: number | null;
  OPERACAO: string;
  VENC: Date | null;
  ALIQUOTA: number;
  DESCRICAO: string;
  MUNICIPIO: string;
  CLASSE_NAO_TRIBUTADO?: string;
  TIPO_TRIBUTACAO?: number;
  ENTRADA: number;
  ALIQUOTA2: number;

  OBS_NAO_TRIBUTADO?: string;
  OBSERVACOES?: string;

  APTIDAO_BOA: number;
  APTIDAO_REGULAR: number;
  APTIDAO_RESTRITA: number;
  PASTAGEM_PLANA: number;
  SIVICULTURA: number;
  RESERVA_NATURAL: number;

  TIPO_TERRA_7: number;
  TIPO_TERRA_8: number;

  MATRICULA: number;
  nao_tributado?: number;
  TRANSCRICAO: string;
}
export type AreaTipo = 'M' | 'P';
export interface IBenfeitoria {
  ID: number;
  AREA: number;
  AREA_TRANSMITIDA: number;
  TIPO: string;
  DESCRICAO: string;
  ANO: string;
  IMOVEL_ID: number;
  MATERIAL: string;
  AREA_TIPO: AreaTipo;
  IMOVEL_RURAL_ID?: number;
}

interface Props {
  id_props?: number;
  id_pesquisa?: number;
}
export function ImovelFocus({ id_props, id_pesquisa }: Props) {
  const navigate = useNavigate();
  const conponentRef = useRef(null);
  const [print, setPrint] = useState(false);
  const [modalImovel, setModalImovel] = useState(false);
  const [enviarImovel, setEnviarImovel] = useState(false);
  const [messageActive, setMessageActive] = useState(false);
  const [anexosEditavel, setAnexosEditavel] = useState(false);
  const [countAnexos, setCountAnexos] = useState(0);
  const [excluirImovelModal, setExcluirImovelModal] = useState(false);
  const [duplicarGuiaModal, setDuplicarGuiaModal] = useState(false);


  const [aliquota, setAliquota] = useState(2);
  const [aliquota2, setAliquota2] = useState(2);
  const [totalDeclaradoMenosEntrada, setTotalDeclaradoMenosEntrada] = useState(0);
  const [entrada, setEntrada] = useState(0);
  const [restanteAvaliacao, setRestanteAvaliacao] = useState(0);


  const {
    funcionarioPrefeituraIsLogged,
    FuncionarioPrefeitura,
    checarTokenFuncionarioPrefeitura,
  } = useFuncionarioPrefeitura();

  const {
    prefeituraIsLogged,
    checarTokenPrefeitura,
    prefeitura,
    bancoPrefeitura,
    logoPrefeitura,
  } = usePrefeitura();
  const params = useParams();
  const [id, setId] = useState(0);
  const { cartorioIsLogged, checarToken, cartorio } = useCartorio();
  const {
    funcionarioCartorioIsLogged,
    checarTokenFuncionario,
  } = useFuncionarioCartorio();
  const { setChave, setNumero, guia } = useGuia();
  const { setImovelFocus } = useImovel();

  const [anexosModal, setAnexosModal] = useState(false);
  const [imovel, setImovel] = useState({} as IImovelFocus);
  const [transmitente, setTransmitente] = useState({} as ITransmitente);
  const { adquirintes, getAdquirintes } = useAdquirinte();
  const adquirente = adquirintes && adquirintes.length > 0 ? adquirintes[0] : {} as IAdquirinte;
  const [benfeitorias, setBenfeitorias] = useState({} as IBenfeitoria[]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({ message: "", title: "" });
  const [editavel, setEditavel] = useState(true);
  const [avaliarImovel, setAvaliarImovel] = useState(false);
  const [reenviarImovelCartorio, setReenviarImovelCartorio] = useState(false);
  const [codigo, setCodigo] = useState("");
  const [prova, setProva] = useState("");
  const { avaliado, getAvaliacao } = useAvaliacao();
  const [helperConfirmAvaliacao, setHelperConfirmAvaliacao] = useState(false);
  const [febraban, setFebraban] = useState("0000");
  const [valorGuia, setValorGuia] = useState(0);

  useEffect(() => {
    const terreonoValorTotal = imovel.VALOR_CARTORIO_TERRENO
      ? imovel.VALOR_CARTORIO_TERRENO
      : 0;
    const benfeitoriasValoTotal = imovel.VALOR_CARTORIO_BENFEITORIAS
      ? imovel.VALOR_CARTORIO_BENFEITORIAS
      : 0;


    setTotalDeclaradoMenosEntrada((terreonoValorTotal + benfeitoriasValoTotal) - (imovel.ENTRADA ? imovel.ENTRADA : 0));

    setEntrada(imovel.ENTRADA);

    setRestanteAvaliacao(((imovel.VALOR_PREFEITURA_TERRENO
      ? imovel.VALOR_PREFEITURA_TERRENO
      : 0) + (imovel.VALOR_PREFEITURA_BENFEITORIAS
        ? imovel.VALOR_PREFEITURA_BENFEITORIAS
        : 0)) - (terreonoValorTotal + benfeitoriasValoTotal))


    if (imovel.ALIQUOTA) {
      setAliquota(imovel.ALIQUOTA);
    }

    if (imovel.ALIQUOTA2) {
      setAliquota2(imovel.ALIQUOTA2);
    }
  }, [
    imovel.VALOR_PREFEITURA_TERRENO,
    imovel.VALOR_PREFEITURA_BENFEITORIAS,
    imovel.ALIQUOTA,
    imovel.ALIQUOTA2,
  ]);

  useEffect(() => {
    if (imovel.ID) setChave(Number("1" + imovel.ID));
    setNumero(Number(imovel.NUMERO));
  }, [imovel.ID]);

  useEffect(() => {
    if (id_props) {
      setId(id_props);
    } else if (params.id) {
      setId(Number(params.id));
    } else {
      setId(0);
    }
  }, [id_props, params]);

  function handleSetBenfeitorias(n_benfeitorias: IBenfeitoria[]) {
    setBenfeitorias(n_benfeitorias);
  }

  function handleSetTransmitente(n_transmitente: ITransmitente) {
    setTransmitente(n_transmitente);
  }


  function handleSetImovel(im: IImovelFocus) {
    setImovel(im);
  }

  async function handleGetData() {
    // window.alert(id)
    // return;
    try {
      setLoading(true);
      if ((cartorioIsLogged || funcionarioCartorioIsLogged) && !id_pesquisa) {
        // if (cartorioIsLogged) {
        //   await checarToken();
        // }
        // if (funcionarioCartorioIsLogged) {
        //   await checarTokenFuncionario();
        // }
        const { data } = await api.get(`/imovel/cartorio/${cartorio.ID}/${id}`);
        setImovel(data[0]);

        setImovelFocus(data[0]);
      } else if (
        !!id_pesquisa ||
        prefeituraIsLogged ||
        funcionarioPrefeituraIsLogged
      ) {
        // if (prefeituraIsLogged) {
        //   await checarTokenPrefeitura();
        // }
        // if (funcionarioPrefeituraIsLogged) {
        //   await checarTokenFuncionarioPrefeitura();
        // }
        // window.alert("CHEGOU AQUI" + " " +`/imovel/prefeitura/${prefeitura.ID}/${id}` )

        const { data } = await api.get(
          `/imovel/prefeitura/${id_pesquisa ? id_pesquisa : prefeitura.ID
          }/${id}`
        );

        setImovel(data[0]);

        setImovelFocus(data[0]);
        //AQUI Q ESTA O ERRO NAO ESTOU COLOCANDO IMOVEL FOCUS
      }

      const transmitente = await api.get(`/transmitente/${id}`);
      // window.alert(JSON.stringify(transmitente.data))
      if (transmitente && transmitente.data[0])
        setTransmitente(transmitente.data[0]);

      const adquirinte = await api.get(`/adquirinte/${id}`);


      const benfeitorias = await api.get(`/benfeitorias/${id}`);
      if (benfeitorias.data[0]) setBenfeitorias(benfeitorias.data);
    } catch (error) {
      setError({
        title: "Ops",
        message: "Não foi possível carregar o imóvel!",
      });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { }, [prefeitura, avaliado]);


  useEffect(() => {
    if (id) handleGetData();
  }, [id]);

  useEffect(() => {
    if (prefeituraIsLogged || funcionarioPrefeituraIsLogged) {
      if (avaliado) {
        if (avaliado.CONFIRMADO == 0) {
          setHelperConfirmAvaliacao(true);
        }
      }
    }

    if (cartorioIsLogged || funcionarioCartorioIsLogged)
      if (imovel.AVALIADO) {
        if (avaliado) {
          if (avaliado.CONFIRMADO == 1) {
            setHelperConfirmAvaliacao(false);
          } else {
            setHelperConfirmAvaliacao(true);
          }
        } else {
          setHelperConfirmAvaliacao(true);
        }
      }
  }, [avaliado, imovel]);

  useEffect(() => {
    if ((imovel.ENVIADO && imovel.CARTORIO_ID) || imovel.AVALIADO) {
      setEditavel(false);
      getAvaliacao(imovel.ID);
    }
  }, [imovel.ID]);
  async function handleBuscaCodigo() {
    try {
      const { data } = await axios.get(
        `${base_url_enderecos_api}/id/${imovel.PREFEITURA_ID}`
      );

      const codBanco = data.banco;
      const febraban = await axios.post(
        `${base_url_unico_api}/prefeitura/codigo-febraban`,
        {
          bancoNum: codBanco.indexOf("2-") != -1 ? 2 : 1,
          bancoNome: codBanco.replaceAll("2-", "").replaceAll("1-", ""),
        }
      );
      setProva(
        `Cheque os dados antes de efetuar o pagamento: Entidade: ${data.titulo} -  Febraban: ${febraban.data.C_FEBRABAN}`
      );
      setFebraban(febraban.data.C_FEBRABAN);

      return febraban.data.C_FEBRABAN;
    } catch (error) {
      //  window.alert("Não foi possível carregar o código febraban!");
    }
    return "";
  }

  useEffect(() => { }, [imovel, prefeitura, imovel.PREFEITURA_ID]);
  async function codigoBarras() {
    if (!imovel || !imovel.ID) {
      setCodigo("");
      return "";
    }

    if (imovel.TIPO_TRIBUTACAO) {
      setCodigo("");
      return "";
    }

    const cod = await handleBuscaCodigo();

    const valorCartorioTerreno =
      imovel.VALOR_CARTORIO_TERRENO != null
        ? imovel.VALOR_CARTORIO_TERRENO
        : 0;

    const valorCartorioBenfeitorias =
      imovel.VALOR_CARTORIO_BENFEITORIAS != null
        ? imovel.VALOR_CARTORIO_BENFEITORIAS
        : 0;

    const valorPrefTerreno =
      imovel.VALOR_PREFEITURA_TERRENO != null
        ? imovel.VALOR_PREFEITURA_TERRENO
        : 0;

    const valorPrefBenfeitorias =
      imovel.VALOR_PREFEITURA_BENFEITORIAS != null
        ? imovel.VALOR_PREFEITURA_BENFEITORIAS
        : 0;

    const entrada =
      imovel.ENTRADA != null
        ? imovel.ENTRADA
        : 0;

    const totalDeclaradoMenosEntrada =
      (valorCartorioTerreno + valorCartorioBenfeitorias) - entrada;

    const restanteAvaliacao =
      (valorPrefTerreno + valorPrefBenfeitorias) -
      (valorCartorioTerreno + valorCartorioBenfeitorias);

    const aliquotaAtual =
      imovel.ALIQUOTA != null
        ? imovel.ALIQUOTA
        : 2;

    const aliquota2Atual =
      imovel.ALIQUOTA2 != null
        ? imovel.ALIQUOTA2
        : 2;

    const valorGuia =
      totalDeclaradoMenosEntrada * (aliquotaAtual / 100) +
      (restanteAvaliacao + entrada) * (aliquota2Atual / 100);
    setValorGuia(valorGuia);
    const novoCodigo = geraCodigo(
      Number("2" + imovel.ID),
      imovel.VENC ? new Date(imovel.VENC) : new Date(),
      valorGuia,
      cod
    );

    setCodigo(novoCodigo);
    return novoCodigo;
  }


  useEffect(() => {
    // window.alert("Deu ceerto código:" + codigo);
    //window.alert(imovel.VALOR_PREFEITURA_BENFEITORIAS + " " + imovel.VALOR_PREFEITURA_TERRENO)
    //  window.alert(`Aqqui ó:ENTRADA:${imovel.ENTRADA} = ${ imovel.ID},
    //  ${ imovel.VENC ? new Date(imovel.VENC) : new Date()},
    //  ${  imovel.ENTRADA?imovel.ENTRADA:0 * (imovel.ALIQUOTA / 100) +
    //      ((imovel.VALOR_PREFEITURA_BENFEITORIAS
    //        ? imovel.VALOR_PREFEITURA_BENFEITORIAS
    //        : 0) +
    //        (imovel.VALOR_PREFEITURA_TERRENO
    //          ? imovel.VALOR_PREFEITURA_TERRENO
    //          : 0) -
    //        (imovel.ENTRADA?imovel.ENTRADA:0)) *
    //        (imovel.ALIQUOTA2 / 100)}`)
    if (imovel && imovel.ID) {
      codigoBarras();
    }
  }, [imovel, prefeitura, aliquota, aliquota2, totalDeclaradoMenosEntrada, entrada, restanteAvaliacao]);

  useEffect(() => {
    console.log(codigo);
  }, [codigo]);

  useEffect(() => {
    if (imovel.ID) defineAnexoEditavel();
  }, [imovel.ID]);

  function defineAnexoEditavel() {
    if (imovel.AVALIADO) {
      setAnexosEditavel(false);
    } else setAnexosEditavel(true);
  }
  useEffect(() => { console.log((codigo)) }, [codigo])

  function renderBody() {
    return (
      <>
        <>
          {/* Seu conteúdo aqui */}
          {/* <h1>{(
            (totalDeclaradoMenosEntrada) * (aliquota / 100) +
            (restanteAvaliacao + entrada) * (aliquota2 / 100)
          )} </h1>
          <h1>{JSON.stringify(retiraVerificadores(codigo))}</h1>

          <h1>{JSON.stringify((codigo))}</h1>  */}

          {guia.COMPUTADA && guia.COMPUTADA.toLowerCase() == "p" ? (
            <> <PagoDiv databaixa={guia.databaixa} /></>
          ) : (
            ""
          )}

          <Header
            imovel={imovel}
            handleSetImovel={handleSetImovel}
            editavel={editavel}
          />
          {/* {codigo}-{imovel.PREFEITURA_ID}   */}
          <TitleSection>TRANSMITENTE</TitleSection>
          <Section>
            <Transmitente
              transmitente={transmitente}
              handleSetTransmitente={handleSetTransmitente}
              editavel={editavel}
            />
          </Section>

          <TitleSection>ADQUIRENTE</TitleSection>
          <Section>
            <Adquirinte
              adquirinte={adquirente}
              handleSetadquirinte={() => { }}
              editavel={editavel}
            />
          </Section>

          <Section>
            <ImovelSection
              imovel={imovel}
              handleSetImovel={handleSetImovel}
              editavel={editavel}
              handleModal={setModalImovel}
            />
          </Section>
          <TitleSection>BENFEITORIAS</TitleSection>
          <Section>
            <BenfeitoriasSection
              benfeitorias={benfeitorias}
              handleSetBenfeitorias={handleSetBenfeitorias}
              editavel={editavel}
            />
          </Section>
          <TitleSection>AVALIAÇÃO</TitleSection>

          <Section>
            <AvaliaçãoContainer
              imovel={imovel}
              handleSetImovel={handleSetImovel}
              editavel={
                editavel ||
                ((prefeituraIsLogged || funcionarioPrefeituraIsLogged) &&
                  !imovel.AVALIADO)
              }
              handleModal={setModalImovel}
            />
          </Section>
        </>
      </>
    );
  }

  function renderCodigoDeBarras() {
    //quando é imovel do cartorio
    if (imovel.AVALIADO && avaliado) {
      if (avaliado.CONFIRMADO == 1) {
        return (
          <GuiaCode
            code={guia.CODBARRA ? guia.CODBARRA : codigo}
            prova={prova}
            febraban={febraban}
            adquirente={adquirente}
            id_entidade={imovel.PREFEITURA_ID}
            id_imovel={imovel.ID}
            valor={valorGuia}
            vencimento={imovel.VENC?imovel.VENC.toString() : ""}
          />
        );
      }
    }
    //return <GuiaCode code={codigo} />;
    //quando é imovel da prefeitura
    if (!imovel.CARTORIO_ID)
      if (imovel.AVALIADO) {
        return (
          <GuiaCode
            code={guia.CODBARRA ? guia.CODBARRA : codigo}
            prova={prova}
            febraban={febraban}
            adquirente={adquirente}
            id_entidade={imovel.PREFEITURA_ID}
            id_imovel={imovel.ID}
            valor={valorGuia}
            vencimento={imovel.VENC?imovel.VENC.toString() : ""}
          />
        );
      }
  }

  useEffect(() => {
    console.log("Este é o barcode: ", codigo);
  }, [codigo]);

  function renderObservacoes() {
    if (imovel.OBSERVACOES != null) {
      if (imovel.OBSERVACOES.length > 0) {
        return (
          <>
            <TitleSection>OBSERVAÇÕES</TitleSection>
            <Section>
              <Observacoes
                imovel={imovel}
                handleSetImovel={handleSetImovel}
                editavel={editavel}
              />
            </Section>
          </>
        );
      }
    }
  }

  return (
    <>
      <>
        <HelpContainer>
          <Container>
            <HelperImpressao>
              <div
                ref={conponentRef}
                style={{ marginBottom: "8px", marginTop: "8px", zoom: 0.4 }}
              >
                <div
                  style={{
                    // marginRight: "5vw",
                    // marginLeft: "5vw",

                    // transformOrigin: "top center",

                    transform: `scale(0.9)`,
                    zoom: 2,
                    // height: "auto",
                  }}
                >
                  {renderBody()}
                  {renderObservacoes()}
                  {/* <br /> */}
                </div>
                {renderCodigoDeBarras()}
              </div>
            </HelperImpressao>
            <div
              style={{
                transform: `scale(${75 / 100})`,
                zoom: `${135 / 100}`,
                transformOrigin: "top center",
              }}
            >
              {renderBody()}

              <>
                <TitleSection>OBSERVAÇÕES</TitleSection>
                <Section>
                  <Observacoes
                    imovel={imovel}
                    handleSetImovel={handleSetImovel}
                    editavel={!imovel.AVALIADO}
                  />
                </Section>
              </>

            </div>
            {/* messageActive && */}

            {/* <FooterLeftButton
          onClick={() => {
            setAnexosModal(true);
          }}
        >
          <Paperclip size={"max(1.8vw,16px)"} />
        </FooterLeftButton> */}

            {/* <ReactToPrint
          content={() => conponentRef.current}
          trigger={() => {
            return (
              <FooterCenterButton>
                <Printer size={"max(1.8vw,16px)"} />
              </FooterCenterButton>
            );
          }}
          onBeforeGetContent={() => {
            setPrint(true);
          }}
          onAfterPrint={() => {
            setPrint(false);
          }}
        />

        {editavel && imovel.CARTORIO_ID ? (
          <FooterRightButton
            onClick={() => {
              setEnviarImovel(true);
            }}
          >
            <Send size={"max(1.8vw,16px)"} />
          </FooterRightButton>
        ) : imovel.CARTORIO_ID ? (
          <>
            {messageActive ? (
              <FooterMessageDiv>
                <MessagesDiv
                  imovel={imovel}
                  onClose={() => {
                    setMessageActive(false);
                  }}
                />
              </FooterMessageDiv>
            ) : (
              <FooterRightButton
                onClick={() => {
                  if (editavel) {
                    setEnviarImovel(true);
                  } else {
                    setMessageActive(true);
                  }
                }}
              >
                <MessageCircle size={"max(1.8vw,16px)"} />{" "}
              </FooterRightButton>
            )}
          </>
        ) : (
          ""
        )}

        {funcionarioPrefeituraIsLogged &&
        !imovel.AVALIADO &&
        FuncionarioPrefeitura.AVALIAR == "S" ? (
          <HeaderButtons>
            {funcionarioPrefeituraIsLogged &&
            !imovel.AVALIADO &&
            FuncionarioPrefeitura.AVALIAR == "S" ? (
              <HeaderRightButtonX
                onClick={() => {
                  setAvaliarImovel(true);
                }}
              >
                <Button variant="contained" style={{ fontWeight: "bold" }}>
                  CONFIRMAR AVALIAÇÃO
                </Button>
              </HeaderRightButtonX>
            ) : (
              ""
            )}
            {imovel.CARTORIO_ID ? (
              <HeaderRightButton
                onClick={() => {
                  setReenviarImovelCartorio(true);
                }}
              >
                <Button
                  color="warning"
                  variant="contained"
                  style={{ fontWeight: "bold" }}
                >
                  CANCELAR AVALIAÇÃO
                </Button>
              </HeaderRightButton>
            ) : (
              ""
            )}

            <HeaderRightTrash
              onClick={() => {
                setExcluirImovelModal(true);
              }}
            >
              <Button
                variant="contained"
                color="error"
                style={{ fontWeight: "bold" }}
              >
                Excluir Imóvel
              </Button>
            </HeaderRightTrash>
          </HeaderButtons>
        ) : (
          ""
        )} */}

            {/* {funcionarioCartorioIsLogged && imovel.ENVIADO == null ? (
          <HeaderRightButtonX
            onClick={() => {
              setExcluirImovelModal(true);
            }}
          >
            <Button
              variant="contained"
              color="error"
              style={{ fontWeight: "bold" }}
            >
              EXCLUIR GUIA
            </Button>
          </HeaderRightButtonX>
        ) : (
          ""
        )} */}

            {/* {imovel.AVALIADO &&
        (funcionarioCartorioIsLogged || cartorioIsLogged) &&
        (!avaliado || avaliado.CONFIRMADO != 1) ? (
          <HeaderRightButton
            onClick={() => {
              setAvaliarImovel(true);
            }}
          >
            <Button
              variant="contained"
              color="error"
              style={{ fontWeight: "bold" }}
            >
              CONFIRMAR OU RECUSAR AVALIAÇÃO
            </Button>
          </HeaderRightButton>
        ) : (
          ""
        )} */}

            <ModalLoader loading={loading} />
            <Alert
              open={error.message.length > 0}
              onClose={() => setError({ message: "", title: "" })}
              title={error.title}
              message={error.message}
            />

            {editavel ? (
              <EnviarImovel
                imovel={imovel}
                open={enviarImovel}
                onClose={() => setEnviarImovel(false)}
                adquirinte={adquirente}
                transmitente={transmitente}
              />
            ) : (
              ""
            )}

            {prefeituraIsLogged || funcionarioPrefeituraIsLogged ? (
              <AvaliarImovel
                imovel={imovel}
                open={avaliarImovel}
                onClose={() => setAvaliarImovel(false)}
                adquirinte={adquirente}
                cod={codigo}
              />
            ) : (
              ""
            )}

            {(cartorioIsLogged || funcionarioCartorioIsLogged) &&
              imovel.AVALIADO ? (
              <AvaliarImovel
                imovel={imovel}
                open={avaliarImovel}
                onClose={() => setAvaliarImovel(false)}
                adquirinte={adquirente}
                cod={codigo}
              />
            ) : (
              ""
            )}

            {imovel.AVALIADO &&
              (cartorioIsLogged || funcionarioCartorioIsLogged) ? (
              <ConfirmarAvaliacaoModal
                open={helperConfirmAvaliacao}
                onClose={() => setHelperConfirmAvaliacao(false)}
                imovel={imovel}
                avaliado={avaliado}
              />
            ) : (
              ""
            )}

            <ReenviarParaCartorio
              open={reenviarImovelCartorio}
              onClose={() => setReenviarImovelCartorio(false)}
              imovel={imovel}
            />

            {imovel.ENVIADO &&
              !imovel.AVALIADO &&
              avaliado != null &&
              (prefeituraIsLogged || funcionarioPrefeituraIsLogged) ? (
              <ConfirmarAvaliacaoModal
                open={helperConfirmAvaliacao}
                onClose={() => setHelperConfirmAvaliacao(false)}
                imovel={imovel}
                avaliado={avaliado}
              />
            ) : (
              ""
            )}

            {/* <h1>Este é o codigo{retiraVerificadores(codigo)}</h1>    */}
            <Anexos
              open={anexosModal}
              onClose={() => setAnexosModal(false)}
              imovel_id={imovel.ID}
              editavel={anexosEditavel}
              emAvaliacao={imovel.ENVIADO != null}
              setCountAnexos={setCountAnexos}
            />

            <ExcluirImovelModal
              imovel={imovel}
              open={excluirImovelModal}
              onClose={() => setExcluirImovelModal(false)}
            />
          </Container>
        </HelpContainer>
      </>
      {!id_pesquisa && (
        <FooterMessageDiv style={{ display: messageActive ? "" : "none" }}>
          <MessagesDiv
            imovel={imovel}
            onClose={() => {
              setMessageActive(false);
            }}
          />
        </FooterMessageDiv>
      )}
      {modalImovel && (
        <FooterImovelFocus
          printComponent={conponentRef.current}
          openMensagem={() => setMessageActive(true)}
          onExcluir={() => setExcluirImovelModal(true)}
          imovel={imovel}
          enviar={() => setEnviarImovel(true)}
          executeAnexos={() => setAnexosModal(true)}
          reenviarCartorio={() => setReenviarImovelCartorio(true)}
          finalizarAvaliacao={() => setAvaliarImovel(true)}
          finalizado={imovel.AVALIADO != null}
          confirmarAvaliacao={
            !!(
              imovel.AVALIADO &&
              (funcionarioCartorioIsLogged || cartorioIsLogged) &&
              (!avaliado || avaliado.CONFIRMADO !== 1)
            )
          }
          confirmarAvaliacaoFunction={() => setAvaliarImovel(true)}
          duplicar={() => setDuplicarGuiaModal(true)}
          countAnexos={countAnexos}
          barrasIncorreto={!!imovel.AVALIADO && codigo.indexOf("NaN") != -1}
        />
      )}
      <DuplicarGuiaModal
        open={duplicarGuiaModal}
        onClose={() => setDuplicarGuiaModal(false)}
        imovel={imovel}
      />
    </>
  );
}
